import React, { useEffect, useState, Fragment, useRef } from "react";
import { TableContentWithoutEdit } from '../../../Common/Table/tableContent';

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const data = this.props.data;
        const contentRowNames = this.props.rowNames;
        const totalCollections = this.props.footerData;

        return (
            <div>
                <h3><center><u>Route Collection Summary Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>OperationEntity: </b> {searchData.operationEntity}</div>
                    <div className="col"><b>CollectionCategory: </b> {searchData.collectionCategory}</div>
                    <div className="col"><b>ToDate: </b> {searchData.toDate}</div>
                    <div className="col"><b>FromDate: </b> {searchData.fromDate}</div>
                </div>
         

                <div> 
                            <table className="table table-bordered pb-3">
                                <thead>
                                    <tr>
                                    <th>Collection Point Name</th>
                                    <th>Actual Amount (Kg)</th>
                                    <th>Gross Amount (Kg)</th>
                                    <th>Net Amount (Kg)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <TableContentWithoutEdit
                                        data={data}
                                        contentRowNames={contentRowNames}
                                        hasEdit={false}
                                    />
                                    
                                </tbody>
                                <tfoot>
                                 <tr>
                                     <td><h6>Total</h6></td>
                                     <td><h6>{totalCollections.actualAmount}</h6></td>
                                     <td><h6>{totalCollections.grossAmount}</h6></td>
                                     <td><h6>{totalCollections.netAmount}</h6></td>
                                 </tr>
                                </tfoot>
                            </table>
                    </div>           
                </div>
        );
    }
}


